import axios from 'axios'

const HTTP = axios.create({
	// baseURL: 'http://localhost:8222'
	baseURL: 'http://52.136.245.244:8222',
})

export { HTTP }



// WEBPACK FOOTER //
// ./src/common/http.js